export default "__VITE_ASSET__d1d54b03__"